import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getImports as getImportsApi,
  updateRow as updateRowApi,
  updateStatus as updateStatusApi,
} from "../../apiCalls/caller";
import { toast } from "react-toastify";

export const getImports = createAsyncThunk(
  "analysis/getImports",
  async (data) => {
    try {      
      const response = getImportsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const updateRow = createAsyncThunk(
  "analysis/updateRow",
  async (data) => {
    try {
      const response = updateRowApi(data);
      return response;
    } catch (error) {
      toast.dismiss();
      toast.success("Error updating data - " + error, {
        position: "top-center",
        autoClose: 2000,
      });
      return error;
    }
  }
);

export const updateStatus = createAsyncThunk(
  "analysis/updateStatus",
  async (data) => {
    try {
      const response = updateStatusApi(data);
      return response;
    } catch (error) {
      console.log("Error", error);
      toast.dismiss();
      toast.success("Error updating status - " + error, {
        position: "top-center",
        autoClose: 2000,
      });
      return error;
    }
  }
);
